<template>
  <div id="schedule" class="address-delivery-time">
    <h2>{{ data.title }}</h2>
    <div class="address-delivery-time-title">{{ data.standartTitle }}</div>
    <address-delivery-time-table />
    <public-text-warning class="w-80">
      <div v-html="data.attention" />
    </public-text-warning>
    <div class="address-delivery-time-title mt-40">{{ data.fixTitle }}</div>
    <div class="address-delivery-time-text" v-html="data.description" />
  </div>
</template>

<script setup lang="ts">
import AddressDeliveryTimeTable from '~/components/public/address-delivery/address-delivery-time-table.vue'
import PublicTextWarning from '~/components/public/public-text-warning.vue'
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/address-delivery')).blocks?.schedule
</script>

<style lang="scss" scoped>
.address-delivery-time {
  margin-top: 110px;

  @media only screen and (max-width: $pub-sm) {
    margin-top: 70px;
  }

  h2 {
    text-align: left;
  }

  &-title {
    position: relative;
    margin-top: 30px;
    font-weight: 700;
    padding-left: 20px;
    margin-bottom: 20px;

    &::before {
      content: '';
      background: $primary;
      position: absolute;
      height: 6px;
      width: 6px;
      top: 9px;
      left: 5px;
    }
  }

  .public-text-warning {
    @media only screen and (max-width: $pub-sm) {
      width: 100%;
    }
  }
}
</style>
